import React from 'react';
import { Polygon, Tooltip } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';

export interface Star4MarkerProps {
    key: string;
    color: string;
    position: any;
    radius: number;
    fteDVMs: number;
    showTooltip: boolean;
    opacity: number;
    name: string;
    isAnimated: boolean;
    onClick?: (event: any) => void;
}

export const Star4Marker = (props: Star4MarkerProps) => {
    const latFactor = 1 / 110540;
    const lngFactor =
        1 / (111320 * Math.cos((props.position[0] * Math.PI) / 180));
    const outerRadiusLat = props.radius * latFactor;
    const outerRadiusLng = props.radius * lngFactor;
    const innerRadiusLat = outerRadiusLat * 0.45;
    const innerRadiusLng = outerRadiusLng * 0.45;

    const points = [];
    for (let i = 0; i < 8; i++) {
        const angle = (Math.PI / 4) * i;
        const rLat = i % 2 === 0 ? outerRadiusLat : innerRadiusLat;
        const rLng = i % 2 === 0 ? outerRadiusLng : innerRadiusLng;
        points.push([
            props.position[0] + rLat * Math.cos(angle),
            props.position[1] + rLng * Math.sin(angle),
        ]);
    }

    const handleClick = (event: any) => {
        if (props.onClick) {
            props.onClick(event);
        }
    };

    return (
        <Polygon
            pane="markerPane"
            eventHandlers={{
                click: handleClick,
            }}
            key={`${props.key}-${props.opacity}`}
            positions={points}
            color="transparent"
            weight={0}
            fillColor={props.color}
            fillOpacity={props.opacity}>
            {!props.isAnimated && props.showTooltip && (
                <Tooltip direction="top">
                    FTE DVMs: {props.fteDVMs} | Type: {props.name}
                </Tooltip>
            )}
        </Polygon>
    );
};
